import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "@/App";
import { ensureServiceWorker } from "@/lib/pwa";
import "@/styles/global.css";

// 서비스워커는 렌더와 무관하게 한 번만 등록한다(오프라인 셸 + 웹 푸시).
void ensureServiceWorker();

const container = document.getElementById("root");
if (!container) throw new Error("#root 요소를 찾을 수 없습니다.");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
